import {
  doc,
  setDoc,
  getDoc,
  collection,
  query,
  orderBy,
  limit as fbLimit,
  getDocs,
  serverTimestamp,
  increment,
} from "firebase/firestore";
import { db } from "../firebase";

// Envía el puntaje de un usuario al torneo. Solo actualiza si el nuevo score es mayor al guardado.
export async function submitScore(gameId, score, user) {
  if (!user?.uid) throw new Error("Usuario no autenticado");

  const scoreRef = doc(db, "tournaments", gameId, "scores", user.uid);
  const existing = await getDoc(scoreRef);
  const previousScore = existing.exists() ? existing.data().score || 0 : 0;

  const payload = {
    userId: user.uid,
    displayName: user.displayName || user.email?.split("@")[0] || "Anónimo",
    email: user.email || null,
    photoURL: user.photoURL || null,
    gamesPlayed: increment(1),
    playedAt: serverTimestamp(),
  };

  if (score > previousScore) {
    payload.score = score;
  }

  await setDoc(scoreRef, payload, { merge: true });
  return { updated: score > previousScore, previousScore };
}

// Trae el ranking ordenado por puntaje, limitado.
export async function getLeaderboard(gameId, limitCount = 100) {
  const scoresRef = collection(db, "tournaments", gameId, "scores");
  const q = query(scoresRef, orderBy("score", "desc"), fbLimit(limitCount));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// Trae el puntaje de un usuario específico.
export async function getUserScore(gameId, userId) {
  if (!userId) return null;
  const scoreRef = doc(db, "tournaments", gameId, "scores", userId);
  const snap = await getDoc(scoreRef);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}
